<template>
  <div class="container">
    <div class="row">
      <div class="col-12 text-center mt-2">
        <h5 class="text-muted">
          Select TM
        </h5>
      </div>
      <div class="col-12 text-center">
        <!-- Tm Selector  -->
        <select
          v-if="tmList"
          name="dispTrackTmSelect"
          class="form-select my-3 animate__animated animate__fadeIn animate__faster"
          v-model="selectedTm"
          @change="setTm">
          <option :value="null">Select TM</option>
          <option
            v-for="t in tmList"
            :key="t.id"
            :value="t">
            {{ t.first_name }} {{ t.last_name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, computed, ref } from 'vue';
  import { useStore } from 'vuex';

  // Initialize
  const store = useStore()
  const emit = defineEmits(['setSelectedTm'])

  // Data
  const selectedTm = ref(null)
  
  // Lifecycle
  onMounted(()=>{
    store.dispatch('displayTrackingSetSelectedTm', null)
    store.dispatch('displayTrackingTmList')
  })

  // Methods
  const setTm = ()=>{
    store.dispatch('displayTrackingSetSelectedTm', selectedTm.value)
  }

  // Computed
  const tmList = computed(()=>{
    const mainList = store.getters.displayTrackingTmList
    const keys = _.keys(mainList)
    let results = []
    _.forEach(keys, k => results = [...results, ...mainList[k]])
    return results
  })

</script>

<style scoped>
  select, option{
    cursor: pointer;
  }
</style>